import {
    SYSTEM_SUBMIT_CERTTYPE_BEGIN,
    SYSTEM_SUBMIT_CERTTYPE_SUCCESS,
    SYSTEM_SUBMIT_CERTTYPE_FAILURE,
    SYSTEM_SUBMIT_CERTTYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitCertType(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_CERTTYPE_BEGIN,
      });
  
      let apiurl = '/api/b/certType/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/certType/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_CERTTYPE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_CERTTYPE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitCertTypeError() {
    return {
      type: SYSTEM_SUBMIT_CERTTYPE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_CERTTYPE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitCertTypePending: true,
          submitCertTypeError: null,
        };
  
      case SYSTEM_SUBMIT_CERTTYPE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitCertTypePending: false,
          submitCertTypeError: null,
        };
  
      case SYSTEM_SUBMIT_CERTTYPE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitCertTypePending: false,
          submitCertTypeError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_CERTTYPE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitCertTypeError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitCertType.js